import { LoginState } from '../../../../common/interface';
import { AURR_STATE_STORAGE_KEY } from '../constants';

/**
 * cache state to local session storage so that we aren't
 * always requesting new tokens
 */
export const setAuthState = (state: LoginState) => {
  localStorage.setItem(AURR_STATE_STORAGE_KEY, JSON.stringify(state));
};
